mainApp.component('apiKeysManagement', {
    templateUrl: '/public/components/api-keys-management.component.html',
    controller: function ($scope, GeneralUtilsService, $state, CopyToClipboardService, UserContextService) {
        const ctrl = this;

        let origKeys = null;
        let eventFeedAccountEnabled = false;

        ctrl.popupId = 'add-api-key' + $scope.$id;
        ctrl.revokePopupId = 'revoke-api-key' + $scope.$id;

        ctrl.$onInit = function () {
            setTableConfig();
            refreshData();
            ctrl.roles = UserContextService.getRoles();
        };

        ctrl.addApiKey = () => {
            ctrl.loadingAddKey = true;
            saveApiKeys(origKeys.concat(ctrl.newApiKey),data => {
                ctrl.loadingAddKey = false;
                $scope.$root.handleServerResponse(data,"", "API Key created successfully");
                if(data.status !== "ERROR"){
                    ctrl.newApiKey = data.model.apiKeys.filter((apiKey) => apiKey.tempId === ctrl.newApiKey.id)[0];
                }
            });
        }

        ctrl.changeEventFeedFlag = () => {
            ctrl.eventFeedConfig.enabled = !ctrl.eventFeedAccountEnabled;
            updateEventFeedFeatureFlag(ctrl.eventFeedConfig, data => {
                    $scope.$root.handleServerResponse(data,"", "Event Feed updated successfully");
                    if(data.status !== "ERROR"){
                        console.info("EventFeed updated successfully")
                    } else {
                        console.error("EventFeed cannot be updated successfully")
                    }
                });
        }

        ctrl.revokeApiKey = () => {
            ctrl.loadingRevoke = true;
            saveApiKeys(origKeys.filter(key => key.id !== ctrl.apikeyToRevoke.id), data => {
                ctrl.loadingRevoke = false;
                $scope.$root.handleServerResponse(data, "", "API Key revoked successfully");
                $scope.$root.closePopup(ctrl.revokePopupId);
            });
        }

        ctrl.closePopup = (popup) => {
            $scope.$root.closePopup(popup);
        }

        ctrl.copyToClipboard = () => {
            CopyToClipboardService.copy(ctrl.newApiKey.key);
            const message = "API Key copied";
            $scope.$root.showNotification('success', message, message);
        }

        // it was requested (by product) to provide the schema download link only to accounts that already have API keys, to minimize the chance someone will use outdated schema
        ctrl.accountHasApiKeys = () => {
            return (origKeys && origKeys.length);
        };

        const setTableConfig = () => {
            ctrl.tableConfig = {
                titleSearch: "Keys",
                clientSideSort: true,
                clientSideSearch: true,
                clientSidePaging: true,
                noDataMessage: 'No keys created yet',
                specialActions: [
                    {
                        icon: 'simple-plus',
                        text: 'Add Key',
                        tooltip: 'Add',
                        id: 'add-key',
                        func: function () {
                            openApiKeyModel();
                        },
                    },
                ],
                fields: [
                    {
                        label: 'Name',
                        path: 'name',
                        width: 4,
                    },
                    {
                        label: 'Creation Date',
                        path: 'creationDate',
                        width: 3,
                    },
                    {
                        label: 'Role',
                        path: 'role',
                        width: 2,
                    },
                    {
                        label: 'Created By',
                        path: 'email',
                        width: 3,
                    },
                    {
                        label: 'Revoke',
                        noSort: true,
                        class: 'revoke-key',
                        template: `
                         <div  data-title="Revoke Key" class="withripple cato-tooltip" style="display: inline-block;" data-ripple-color="#efefef" ng-click="tableConfig.revoke(item)">
                            <svg class="icon icon-trash" style="height: 15px;width: 15px"><use xlink:href="/public/images/icons/main.svg#icon-trash"></use></svg>
                        </div>
                        `,
                    },
                ],
                parseData: function () {
                    return origKeys;
                },
                defer: true,
                pageSize: 100,
                sortList: [{ sortField: 'name', sortDir: 'ASC' }],
                hideCheckboxes: true,
                noAutoSelect: true,
                innerLoader: true,
                revoke: (item) => {
                    revokeKeyConfirm(item);
                }
            };

        }

        const refreshData = () => {
            refreshApiKeys();
            getEventFeedAccountConfiguration();
        }

        const refreshApiKeys = () => {
            store.fetch({
                path: "getApiKeys",
                queryParams: {
                    accountId: $state.params.accountId,
                },
                success: (data) => {
                    origKeys = data;
                    ctrl.refreshTable = new Date().getTime();
                    $scope.$digest();
                }
            })
        }


        const getEventFeedAccountConfiguration = () => {
            store.fetch({
                path: "getEventFeedAccountConfiguration",
                queryParams: {
                    accountId: $state.params.accountId,
                },
                success: (data) => {
                    ctrl.eventFeedConfig = data;
                    ctrl.eventFeedAccountEnabled = data.enabled;
                    $scope.$digest();
                }
            })
        }

        const revokeKeyConfirm = (apikeyToRevoke) => {
            $scope.$root.openPopup(ctrl.revokePopupId);
            ctrl.apikeyToRevoke = apikeyToRevoke;
        }

        const saveApiKeys = (apiKeysArray, callBack) => {
            store.save({
                path: '/edit',
                queryParams: {
                    accountId: $state.params.accountId,
                    save: true,
                    fields: "['apiKeys']",
                },
                data: {
                    apiKeys: apiKeysArray,
                    newSaveMethod: true,
                    id: $state.params.accountId
                },
                dataObj: 'json',
                success: (data) => {
                    if (data.status !== "ERROR") {
                        origKeys = data.model.apiKeys;
                    }
                    ctrl.refreshTable = new Date().getTime();

                    callBack(data);

                    $scope.$digest();
                }
            });
        }

        const updateEventFeedFeatureFlag = (eventFeedConfig, callBack) => {
            store.save({
                path: '/edit',
                queryParams: {
                    accountId: $state.params.accountId,
                    save: true,
                    fields: "['eventFeedConfig']",
                }, data: {
                    eventFeedConfig: eventFeedConfig,
                    newSaveMethod: true,
                    id: $state.params.accountId
                },
                dataObj: 'json',
                success: (data) => {
                    callBack(data);
                    $scope.$digest();
                }
            });
        }

        const openApiKeyModel = () => {
            ctrl.newApiKey = {
                id: GeneralUtilsService.getRandomId(),
                name: null,
                role: UserContextService.getRoles().VIEWER,
            };
            $scope.$root.openPopup(ctrl.popupId);
        }
    }
});
